<div class="modal-header">
  <h4 class="modal-title">{{'compareItemListsComponent.title' | translate}}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <div class="mb-3 row mb-0" >
      <label class="col-md-12 col-form-label">{{'compareItemListsComponent.label.text' | translate}}</label>
    </div>
    <div class="mb-3 row mb-0" >
      <label class="col-md-12 col-form-label font-weight-bold">{{'compareItemListsComponent.label.colA' | translate}} = {{projectNameStringA}}</label>
    </div>
    <div class="mb-3 row mb-0" *ngIf="projectA.articleNumberLong?.reducedArticleNumberLong">
      <label class="col-md-12 col-form-label">{{ projectA.articleNumberLong?.reducedArticleNumberLong }}</label>
    </div>
    <div class="mb-3 row mb-0" >
      <label class="col-md-12 col-form-label break-word">{{projectPathStringA}}</label>
    </div>
    <div class="mb-3 row mb-0" >
      <label class="col-md-12 col-form-label font-weight-bold">{{'compareItemListsComponent.label.colB' | translate}} = {{projectNameStringB}}</label>
    </div>
    <div class="mb-3 row mb-0" *ngIf="projectB.articleNumberLong?.reducedArticleNumberLong">
      <label class="col-md-12 col-form-label">{{ projectB.articleNumberLong?.reducedArticleNumberLong }}</label>
    </div>
    <div class="mb-3 row mb-0" >
      <label class="col-md-12 col-form-label break-word">{{projectPathStringB}}</label>
    </div>

    <div class="mb-3 row mb-0" *ngIf="statusMessage">
      <label class="col-md-12 col-form-label error">{{statusMessage | translate}}</label>
    </div>

    <div *ngIf="!statusMessage" #compareListDiv>
      <table class="table table-striped fixed-layout" fixedHeader>
        <thead>
          <tr>
            <th class="article-number-column">{{'compareItemListsComponent.label.itemNumber' | translate}}</th>
            <th class="article-count-column text-end">{{'compareItemListsComponent.label.colA' | translate}}</th>
            <th class="article-count-column text-end">{{'compareItemListsComponent.label.colB' | translate}}</th>
            <th class="padding-column"></th>
          </tr>
        </thead>
      </table>
      <div class="container-custom-list" maxHeightOffset="450">
        <table class="table table-striped fixed-layout table-wrap">
          <tbody>
            <tr *ngFor="let entry of comparedList; let i = index" data-testid="compare-bill-of-materials-article-row" [class.row-contains-unequal-comparison]="entry.amountA != entry.amountB">
              <td class="article-number-column">{{entry.articleNumber}}</td>
              <td class="article-count-column text-end"><span *ngIf="entry.amountA">{{entry.amountA}}</span></td>
              <td class="article-count-column text-end"><span *ngIf="entry.amountB">{{entry.amountB}}</span></td>
              <td class="padding-column"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button"
          class="btn btn-secondary btn-forward"
          (click)="saveAsCSV()">
    {{'compareItemListsComponent.label.save_as_csv' | translate}}
  </button>
  <button type="button"
          class="btn btn-primary btn-cancel"
          (click)="onCancel()">
    {{'global.label.close' | translate}}
  </button>
</div>
